import { TranslateLoader } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';

export class FileImportLoader implements TranslateLoader {
    getTranslation(lang: string): Observable<any> {
        return  from(import(`./${lang}.json`));
    }
}
